<template>
  <div>
    <div class="red--text lighten-2 caption error-div" v-if="error">
      {{ error }}
    </div>
    <div class="counter" v-if="count && !error">
      {{ count }}/8
    </div>
    <div class="entry">
      <input type="text" maxlength="8" v-model="shareCode" placeholder="Share Code" @keyup.enter="submit"/>
    </div>
    <div class="go" v-if="loading">
      <v-progress-circular
        size="16"
        width="2"
        indeterminate
        color="white"
      ></v-progress-circular>
    </div>
    <div class="go" @click="submit" v-else>
      GO
    </div>
    <v-dialog v-model="showLiveLauncher" max-width="278">
      <v-layout wrap white pa-3>
        <v-flex xs12 headline text-xs-center mb-3>
          <v-icon x-large color="accent" class="custom-fab">connect_without_contact</v-icon>
        </v-flex>
        <v-flex xs12 text-xs-center>
          <a :href="liveURI" target="_blank" @click="showLiveLauncher = false">
            <v-btn color="accent" block large>Join Live Session</v-btn>
          </a>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
import ShareService from '@/services/ShareService'

export default {
  data() {
    return {
      loading: null,
      error: null,
      count: null,
      shareCode: '',
      liveURI: null,
      showLiveLauncher: false
    };
  },
  computed: {
    shareCodeIsValid: function () {
      if (this.shareCode.length === 8) return true;
      return false;
    },
  },
  watch: {
    shareCode: function () {
      this.error = null;
      this.count = this.shareCode.length;
    } 
  },
  methods: {
    async submit() {
      if (!this.shareCodeIsValid) {
        this.error = '8 characters required.'
        return;
      }
      this.loading = true;

      const code = this.shareCode;

      // check if the code is for a live session
      try {
        const requestOptions = {
          method: "POST",
          headers: {"Content-Type" : "application/json"}
        };

        const response = await fetch("https://api.live.brainingcamp.com/live/api/sessions/" + code + "/join", requestOptions)
        
        if (response.ok) {
          const data = await response.json();
          // TODO: add redirectUri checks here before trying to open a window
          this.liveURI = data.redirectUri;
          this.showLiveLauncher = true;
          this.loading = false
          return;
        } 
      } catch (err) {
        // fail silently to try share code
      }

      // check if the code is for a share
      try {
        const result = await ShareService.get(code);

        var file = result.data.payload;

        this.$router.push({
          path: '/manipulatives/' + file.appId + '/' + code
        })
      } catch (err) {
        this.error = err.response.data.error;
      }
      this.loading = false
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
.custom-fab {
  width: 70px;
  height: 70px;
  background-color: #FBEEE9;
  border-radius: 35px;
}

.counter {
  vertical-align: middle;
  display: inline-block;
  margin-right: 8px;
}

.error-div {
  vertical-align: middle;
  display: inline-block;
  margin-right: 8px;
}

.entry {
  vertical-align: middle;
  display: inline-block;
  border: 1px solid #DAD9E0;
  border-radius: 4px 0px 0px 4px;
}

.entry input {
  border: 0;
  text-transform: uppercase;
  font-size: 14pt;
  padding: 0 8px;
  width: 140px;
  height: 40px;
}

.go {
  vertical-align: middle;
  display: inline-block;
  border: 1px solid #e91e63;
  background-color: #e91e63;
  border-radius: 0px 4px 4px 0px;
  width: 70px;
  height: 42px;
  color: white;
  font-size: 14pt;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  padding-top: 6px;
}

.disabled {
  border: 1px solid #e0e0e0;
  background-color: #e0e0e0;
  color: #a6a6a6;
}
</style>
